// The node object react-d3-tree walks, and the one field on it that lies.
//
// Kept apart from the card that renders it so it can be tested without pulling
// React and a stylesheet into the test bundle.

export interface TreeNodeDatum {
  /**
   * NOT a name, and not the node id either. `assembleTreeStructure` packs the
   * id, the raw SQL test and four formatted statistics into one string:
   *
   *   `5 ' ~ ' CAST(COALESCE(employees, '-333') AS NUMERIC) >= ...
   *      145 observations / 24.1% rate
   *      9.5% of leads
   *      11.4% of conversions`
   *
   * Only the leading integer is ever wanted. Read it with `nodeIdOf`, never by
   * rendering this field: it opens with the id, so a prefix looks right, and
   * printing it whole spills SQL across the card.
   */
  name: string;
  population?: number;
  conversions?: number;
  percentPopulation?: number;
  splitConditions?: string;
  /** Whether this node is the true or the false side of its parent's test. */
  ifTrue?: boolean;
  sumConditions?: string;
  color?: string;
  children?: TreeNodeDatum[];
}

/** The node id out of the composite `name`. Null when there is no leading integer. */
export function nodeIdOf(datum: TreeNodeDatum): number | null {
  const id = parseInt(datum.name, 10);
  return Number.isFinite(id) ? id : null;
}
